import { INSIGHT_STATUS_DESCRIPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { StatusType } from '@silverfort/sf-components';

// these options are used in filter named entity status
export const ENTITY_STATUS_OPTIONS = [
    { title: INSIGHT_STATUS_DESCRIPTIONS.OPEN, value: INSIGHT_STATUS_DESCRIPTIONS.OPEN },
    { title: INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS, value: INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS },
    { title: 'Accepted Risk', value: INSIGHT_STATUS_DESCRIPTIONS.ACCEPTED },
    { title: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED, value: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED }
];

/**
 * Maps each entity status to an array of corresponding insight status descriptions.
 * Used for translating entity statuses to insight status descriptions in filters and UI components.
 */
export const ENTITY_STATUS_TO_INSIGHT_STATUS_DESCRIPTIONS_MAP: Record<string, Array<string>> = {
    [INSIGHT_STATUS_DESCRIPTIONS.OPEN]: [INSIGHT_STATUS_DESCRIPTIONS.OPEN],
    [INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS]: [INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS],
    [INSIGHT_STATUS_DESCRIPTIONS.ACCEPTED]: [INSIGHT_STATUS_DESCRIPTIONS.ACCEPTED],
    [INSIGHT_STATUS_DESCRIPTIONS.RESOLVED]: [
        INSIGHT_STATUS_DESCRIPTIONS.RESOLVED,
        INSIGHT_STATUS_DESCRIPTIONS.FALSE_POSITIVE,
        INSIGHT_STATUS_DESCRIPTIONS.PROTECTED,
        INSIGHT_STATUS_DESCRIPTIONS.MITIGATED
    ]
};

/**
 * Maps each insight status description to its corresponding entity status.
 * Used for translating insight status descriptions to entity statuses in filters and UI components.
 */
export const INSIGHT_STATUS_DESCRIPTIONS_TO_ENTITY_STATUS_MAP: Record<string, string> = {
    [INSIGHT_STATUS_DESCRIPTIONS.ACCEPTED]: INSIGHT_STATUS_DESCRIPTIONS.ACCEPTED,
    [INSIGHT_STATUS_DESCRIPTIONS.FALSE_POSITIVE]: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED,
    [INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS]: INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS,
    [INSIGHT_STATUS_DESCRIPTIONS.MITIGATED]: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED,
    [INSIGHT_STATUS_DESCRIPTIONS.OPEN]: INSIGHT_STATUS_DESCRIPTIONS.OPEN,
    [INSIGHT_STATUS_DESCRIPTIONS.PROTECTED]: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED,
    [INSIGHT_STATUS_DESCRIPTIONS.RESOLVED]: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED
};

export const getInsightStatusDescriptionsByEntityStatus = (entityStatus?: string | Array<string>) => {
    if (!entityStatus) return undefined;

    if (Array.isArray(entityStatus)) {
        return entityStatus.reduce<Array<string>>((arr, item) => {
            const mappedValue = ENTITY_STATUS_TO_INSIGHT_STATUS_DESCRIPTIONS_MAP[item];

            return arr.concat(mappedValue);
        }, []);
    }

    return ENTITY_STATUS_TO_INSIGHT_STATUS_DESCRIPTIONS_MAP[entityStatus];
};

export const getEntityStatusByInsightStatusDescriptions = (insightStatus?: Array<string>) => {
    if (!insightStatus) return undefined;

    const set = new Set(insightStatus.map((status) => INSIGHT_STATUS_DESCRIPTIONS_TO_ENTITY_STATUS_MAP[status]));

    return [...set];
};

export const ENTITY_STATUS_TOOLTIP_MAP: Record<string, string> = {
    [INSIGHT_STATUS_DESCRIPTIONS.FALSE_POSITIVE]: 'False Positive',
    [INSIGHT_STATUS_DESCRIPTIONS.PROTECTED]: 'Compensating controls',
};

export const ENTITY_STATUS_TO_STATUS_TYPE_MAP: Record<string, StatusType> = {
    [INSIGHT_STATUS_DESCRIPTIONS.OPEN]: StatusType.Default,
    [INSIGHT_STATUS_DESCRIPTIONS.IN_PROGRESS]: StatusType.Warning,
    [INSIGHT_STATUS_DESCRIPTIONS.ACCEPTED]: StatusType.Disabled,
    [INSIGHT_STATUS_DESCRIPTIONS.RESOLVED]: StatusType.Success
};
